import React from 'react';
import { Box, TableCell, TableSortLabel } from '@mui/material';

const ResizableHeaderCell = ({
  width,
  minWidth,
  onResizeStart,
  children,
  sortable = false,
  sortActive = false,
  sortDirection = 'asc',
  onSort,
  sx,
  ...props
}) => (
  <TableCell
    {...props}
    sx={{
      width,
      ...(minWidth != null && minWidth !== '' ? { minWidth } : {}),
      position: 'relative',
      '& .MuiTypography-root': {
        fontWeight: 700
      },
      '& .MuiTableSortLabel-root': {
        fontWeight: 700
      },
      ...sx,
      '&.MuiTableCell-stickyHeader': {
        // Last so caller sx cannot override sticky; top/z-index come from the parent Table sx.
        position: 'sticky',
        backgroundColor: 'background.paper'
      }
    }}
  >
    <Box sx={{ pr: 1.5 }}>
      {sortable ? (
        <TableSortLabel
          active={sortActive}
          direction={sortDirection}
          onClick={onSort}
        >
          {children}
        </TableSortLabel>
      ) : children}
    </Box>
    <Box
      role="separator"
      aria-orientation="vertical"
      onMouseDown={onResizeStart}
      onClick={(e) => e.stopPropagation()}
      sx={{
        position: 'absolute',
        top: 0,
        right: -2,
        width: 8,
        height: '100%',
        cursor: 'col-resize',
        zIndex: 2,
        '&::after': {
          content: '""',
          position: 'absolute',
          right: 2,
          top: 5,
          bottom: 5,
          width: 2,
          borderRadius: 1,
          bgcolor: 'grey.400',
          opacity: 0.75
        },
        '&:hover::after': {
          bgcolor: 'primary.main',
          opacity: 1
        }
      }}
    />
  </TableCell>
);

export default ResizableHeaderCell;

